import { TeamMember } from '../types';
import headshot from '../assets/cichon-headshot-160x215.318b9bee.webp';
import headshot3 from '../assets/NYU headshot.png';
import headshot4 from '../assets/1.png';
import headshot5 from '../assets/Headshot.jpg';
import headshot6 from '../assets/IMG_2041.jpg';

// Cichon Lab Members - Principal Investigator, Postdocs, Grad Students, and Visiting Scholars
export const labMembers: TeamMember[] = [
  {
    name: 'Joseph Cichon, MD, PhD',
    role: 'Assistant Professor of Anesthesiology & Critical Care',
    photo: headshot,
    research: 'Joseph Cichon, MD, PhD, is a physician–neuroscientist and Assistant Professor of Anesthesiology & Critical Care at the University of Pennsylvania. Trained as an MD/PhD at NYU and subsequently a research fellow at Penn, Dr. Cichon has helped define circuit mechanisms that underlie dissociative actions of ketamine. Combining two-photon imaging with opto/chemogenetics and behavior, his lab maps layer- and cell-type specific cortical dynamics to understand how anesthetics, rapid-acting antidepressants, and psychedelics reshape circuits to alter consciousness, mood, and pain.',
  },
  {
    name: 'Stephen Wisser, BS',
    role: 'Graduate Student',
    research: 'Modeling acute to chronic pain transition',
  },
];

export const undergraduateResearchers: TeamMember[] = [
  {
    name: 'Meah Ahmed',
    role: 'Undergraduate Researcher',
    photo: headshot3,
    research: 'EEG evaluation of brain states',
  },
  {
    name: 'Amanda Choi',
    role: 'Undergraduate Researcher',
    photo: headshot6,
    research: 'Novel behavior modeling of maternal depression',
  },
  {
    name: 'Austin Lin',
    role: 'Undergraduate Researcher',
    research: 'Mapping cortical psychedelic response',
  },
  {
    name: 'Sadia Rahman',
    role: 'Undergraduate Researcher',
    photo: headshot5,
    research: 'Testing novel rapid acting antidepressants',
  },
  {
    name: 'Alan Ying',
    role: 'Undergraduate Researcher',
    photo: headshot4,
    research: 'Testing the necessity of psychedelic subjective effects',
  },
];

export const alumni: TeamMember[] = [
  {
    name: 'Ahmad Hammo, BS',
    role: 'Alumni, Former Undergraduate Researcher',
    research: 'Washington University School of Medicine in St. Louis, St. Louis, MO',
  },
  {
    name: 'Dan Markman, BS',
    role: 'Alumni, Former Undergraduate Researcher',
    research: 'Sidney Kimmel Medical College at Thomas Jefferson University, Philadelphia, PA',
  },
];


